__turbopack_context__.v({
  "techDropdown": "CaseStudyFilters-module__5QQVoG__techDropdown",
});
